import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Target, Mail } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function XclusiveAgentLeads() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-569" data-mp="2q56fk9id1ey7">
      <div className="max-w-6xl mx-auto px-4" data-id="element-570" data-mp="2q7ak8to32hzj">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-571" data-mp="2l6v7o4bmleim">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-572" data-mp="2bfiixll4j4gt" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-573" data-mp="27fzuifu3gb98">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-574" data-mp="27cvk30q1cja4">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-575" data-mp="22eajh06vfxl5">
              Paid Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-576" data-mp="1nxs70ke9v1r1">
              Retargeting
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-577" data-mp="1ezpvhawwwqpi">
              E-Commerce
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-578" data-mp="27n2g3fjiiog6">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-579" data-mp="2bml3qj2pxdmp">
            Dominating Agent Lead Gen With a Full-Funnel System
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-580" data-mp="ma966m4l9pxi">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-581" data-mp="m97v4hnkp3fs">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-582" data-mp="r8ss4mj6n1pv">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-583" data-mp="792ghn5we9gq">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-584" data-mp="3uk22mnvexhql" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-585" data-mp="3uhp9rfo49myr">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-586" data-mp="3pkp6tdmkd0bv">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-587" data-mp="3fn17eae0j4nd" />
                </div>
                <div data-id="element-588" data-mp="3bl64x2kcil80">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-589" data-mp="3bkecu1pyj5mh">
                    +18%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-590" data-mp="36o5z8srerkhf">
                    Sales Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-591" data-mp="1ce90ysqgfb7p">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-592" data-mp="1hbhl2yv5xpbl">
                <Target className="w-24 h-24 text-engage-yellow" data-id="element-593" data-mp="1m658svicefp4" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-594" data-mp="1r2c6k10l4kvz">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-595" data-mp="tgoj45m3xcwl">
                  <Target className="w-6 h-6 text-engage-yellow" data-id="element-596" data-mp="ygax4h9rex6g" />
                </div>
                <div data-id="element-597" data-mp="13fnn3avxgkd9">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-598" data-mp="17f625q12i186">
                    5.36x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-599" data-mp="2es6ga9plxtc0">
                    Blended ROAS
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-600" data-mp="2hf8k4b9mqijn">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-601" data-mp="2rc3hgqu62cwc">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-602" data-mp="2manwszvwi8eh" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-603" data-mp="30ayqsbsic33v">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-604" data-mp="2vdp2izgutxhm">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-605" data-mp="3a11qsvy1qhbp" />
                </div>
                <div data-id="element-606" data-mp="3541n2roo5qnr">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-607" data-mp="354tfxuqvtaac">
                    +67%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-608" data-mp="3f1pilju3n26z">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-609" data-mp="3op1qknmjbk4g">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-610" data-mp="3oquys7csqcek">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-611" data-mp="3tpg1cdfit866">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-612" data-mp="3jp5q2yd1qatn" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-613" data-mp="3jra2k4p0gi5j">
              The Christmas Palace needed their "Christmas in July" campaign to
              perform like peak season—without sacrificing profitability or
              brand perception. With growing traffic but under-converting
              add-to-carts, the challenge was clear: scale revenue across Meta,
              Google, and email simultaneously while maintaining efficiency,
              strong ROAS, and a premium customer experience.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-614" data-mp="xqf8usub2a6n">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-615" data-mp="xqnlqkqfhfhu">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-616" data-mp="sphrgih4dk67" />
              <div className="relative z-10" data-id="element-617" data-mp="1lh1gij0edsg4">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-618" data-mp="1le5iyvsgp5s7">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-619" data-mp="1billw625w11v" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-620" data-mp="51gp5rajazz8">
                  We built a campaign designed for performance at every level.
                  High-impact creative led the strategy, supported by a
                  multi-campaign paid media structure and aggressive testing
                  cycles that allowed us to scale what worked in real time. At
                  the same time, we re-engineered email into a high-frequency,
                  segmented conversion channel—ensuring demand was not only
                  captured, but fully monetized across every touchpoint.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-621" data-mp="8rkh0ivoijxo">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-622" data-mp="innkpt66iqmq" />
              <div className="relative z-10" data-id="element-623" data-mp="nlyuk3wh514y">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-624" data-mp="2kf0nabkocmfm">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-625" data-mp="2pemyygkutumb" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-626" data-mp="v583jw12ixth">
                  The campaign delivered strong, profitable growth in the middle
                  of the off-season—proving that demand could be created, not
                  just captured. Revenue increased, returning customer rate
                  surged, and performance remained efficient across all
                  channels. What is traditionally a slow period became a
                  high-performing revenue window, turning July into an extension
                  of peak season.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-627" data-mp="h6guio12c2c7">
            <div className="flex justify-center mb-8" data-id="element-628" data-mp="1wle7c968kf3a">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-629" data-mp="1slniwc46mb1x">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-630" data-mp="251wprrvh246h" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-631" data-mp="294td1vvyiogr">
              We turned the off-season into a revenue driver—making July perform
              like peak season.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-632" data-mp="36m9w1vdrblww">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 flex items-center justify-center overflow-hidden bg-gradient-to-br from-engage-gray2 to-engage-gray3" data-id="element-633" data-mp="jsc5f7hftbml">
                <svg className="w-9 h-9 md:w-11 md:h-11 text-engage-gray4" viewBox="0 0 24 24" fill="currentColor" data-id="element-634" data-mp="9sbf31l5hv8w">
                  <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" data-id="element-635" data-mp="28p7a9bsxes" />
                </svg>
              </div>
              <div className="font-bold text-engage-white text-lg" data-id="element-636" data-mp="3n9apviosj21l">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-637" data-mp="3s4zvo3relf6c">
                The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-638" data-mp="2yn4qxh5vr77o">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-639" data-mp="2umkru81qxtiw" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-640" data-mp="38mlt3olxb2yw">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-641" data-mp="33ly3969fks69">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-642" data-mp="3hjw5xeee305x">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-643" data-mp="3rb0mujnmkv3e">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}